import * as React from "react";
import { cn } from "@/lib/utils";

const OUTER_PATH_D =
	"M 801.685 377.384 C 807.749 376.632 823.192 377.02 830.097 377.022 L 883.504 377.05 L 1064.71 377.034 L 1359.01 377.034 L 1448.88 376.961 C 1469.62 376.904 1511.39 372.058 1526 388.664 C 1537.08 401.248 1529.93 422.475 1526.81 437.201 C 1521.89 460.37 1515.81 483.59 1510.42 506.836 L 1486.95 606.502 C 1482.33 626.095 1477.15 661.503 1464.52 677.035 C 1452.09 692.319 1424.07 689.173 1405.21 689.165 L 1341.39 689.12 L 1082.61 689.095 L 994.318 689.029 C 979.191 689.019 963.828 688.419 948.733 689.153 C 945.465 689.312 937.163 689.719 934.951 692.099 C 932.533 694.702 932.245 700.188 932 703.542 C 930.313 726.595 931.915 756.081 931.915 779.719 C 931.916 812.367 930.427 845.651 932.412 878.08 C 933.263 877.991 934.116 877.911 934.968 877.841 C 954.112 876.257 990.251 877.439 1010.36 877.486 L 1149.22 877.632 L 1267.17 877.756 C 1287.2 877.782 1308.24 876.559 1328.16 878.31 C 1334.96 878.908 1342.18 881.308 1347.33 885.929 C 1353.04 891.046 1358.19 899.784 1358.13 907.64 C 1358.02 923.464 1306.07 1077.73 1296.67 1097.48 C 1292.88 1105.44 1287.03 1112.69 1280.78 1118.86 C 1256 1143.38 1224.5 1144.22 1191.84 1144.17 L 1017.43 1144.05 C 1000.37 1144.03 946.149 1142.94 932.99 1145.67 C 928.066 1151.12 929.946 1216.51 929.941 1228.87 L 929.654 1402.91 C 929.528 1430.16 929.725 1457.89 929.1 1485.13 C 928.94 1492.11 925.41 1508.85 920.146 1513.15 C 905.69 1524.97 887.235 1533.16 870.517 1541.89 C 843.784 1555.78 816.953 1569.48 790.026 1583 C 752.983 1602.17 715.806 1621.09 678.497 1639.74 C 655.692 1651.21 627.575 1667.49 603.277 1673.68 C 582.265 1679.04 555.181 1665.49 554.013 1641.96 C 553.502 1631.66 553.814 1620.29 553.812 1609.53 L 553.802 1538.39 L 553.816 1297.65 L 553.763 901.274 L 553.789 768.029 C 553.826 745.078 553.642 721.93 554.262 699.018 C 554.633 685.305 566.111 666.894 579.851 663.174 C 595.055 659.058 611.209 660.146 626.844 660.214 L 698.135 660.222 C 711.251 660.261 725.344 661.428 738.282 659.828 C 743.245 659.215 751.932 657.52 754.94 652.929 C 763.102 640.472 753.951 450.532 759.321 414.66 C 760.474 406.957 762.394 399.363 767.483 393.255 C 776.289 382.686 788.432 378.447 801.685 377.384 z";

const INNER_PATH_D =
	"M 1183.52 384.504 L 1410.95 384.007 L 1469.27 383.928 C 1479.71 383.922 1496.13 383.104 1505.92 385.154 C 1534.79 391.201 1521.87 424.486 1517.37 443.688 L 1507.07 488.985 L 1470.12 644.366 C 1466.6 658.608 1463.91 672.009 1449.11 678.479 C 1434.6 684.826 1362.08 682.018 1341.22 682.018 L 1077.14 681.98 L 989.869 681.902 C 976.537 681.895 937.418 679.872 927.284 685.98 C 922.181 695.801 923.889 751.282 923.89 766.371 L 924.123 885.063 L 1194.68 885.133 L 1282.52 885.163 C 1296.16 885.15 1310.65 883.999 1324.21 885.34 C 1331.56 886.066 1339.52 887.919 1344.8 893.466 C 1349.02 897.895 1350.17 902.283 1350.04 908.298 C 1349.61 928.396 1326.07 989.788 1318.63 1011.91 L 1300.64 1064.7 C 1296.76 1075.91 1292.61 1088.86 1287.15 1099.3 C 1277.8 1117.15 1252.16 1132.59 1232.51 1134.9 C 1206.68 1137.94 1177.42 1136.48 1151.1 1136.45 L 992.683 1136.4 C 977.36 1136.38 961.968 1136.04 946.668 1136.21 C 934.956 1136.34 922.814 1135.76 922.187 1150.75 C 921.683 1162.79 921.934 1174.64 921.944 1186.66 L 921.985 1257.5 L 922.036 1408.31 C 922.04 1422.79 924.977 1498.22 915.471 1506.54 C 899.801 1520.25 862.212 1537.46 841.791 1547.88 L 746.302 1596.65 L 663.522 1638.43 C 647.964 1646.26 632.545 1653.99 616.783 1661.52 C 597.604 1670.69 562.915 1668.48 562.206 1641.18 C 561.672 1620.63 561.964 1599.74 561.992 1579.09 L 562.024 1468.85 L 561.909 1120.49 L 561.915 837.361 L 561.98 747.587 C 561.996 731.749 561.761 715.82 562.328 699.988 C 562.302 685.975 573.892 669.577 589.55 668.755 C 636.904 666.317 685.273 669.05 732.725 667.926 C 750.549 667.503 764.062 662.535 764.522 643.184 C 764.987 623.601 764.782 603.805 764.871 584.257 L 765.567 460.002 C 765.714 445.365 764.691 422.806 767.34 408.845 C 772.972 379.158 817.924 384.968 838.952 384.977 L 917.704 384.983 L 1183.52 384.504 z";

export interface LogoIconProps extends React.SVGAttributes<SVGSVGElement> {
	title?: string;
	bare?: boolean;
	animateDraw?: boolean;
}

export const LogoIcon = React.forwardRef<SVGSVGElement, LogoIconProps>(
	(
		{
			className,
			title = "AgentFramer",
			bare = false,
			animateDraw = false,
			...props
		},
		ref,
	) => {
		return (
			<svg
				ref={ref}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 2048 2048"
				width="32"
				height="32"
				role="img"
				aria-label={title}
				className={cn("shrink-0", className)}
				{...props}
			>
				{bare ? (
					<path d={OUTER_PATH_D} fill="currentColor" />
				) : (
					<>
						<rect width="2048" height="2048" rx="460" fill="#6B3FF2" />
						<path
							d={INNER_PATH_D}
							fill="#FFFFFF"
							className={animateDraw ? "logo-af-fill" : undefined}
						/>
						{animateDraw ? (
							<path
								d={INNER_PATH_D}
								fill="none"
								stroke="#FFFFFF"
								strokeWidth={30}
								strokeLinejoin="round"
								strokeLinecap="round"
								pathLength={1}
								className="logo-af-trace"
							/>
						) : null}
					</>
				)}
			</svg>
		);
	},
);
LogoIcon.displayName = "LogoIcon";
